<script setup lang="ts">
    import {icons} from "../../icons.ts";
    import type {HTMLAttributes} from "vue";
    import {tw} from "../../utils/tailwind.ts";

    const props =defineProps<{
        name: string
        class?: HTMLAttributes['class']
    }>()
</script>

<template>
    <component :is="icons[name]" :class="tw('', props.class)" />
</template>
